import {hideWrapper} from '../components/hideWrapper';

export default () => {
    let locations = [];
    let countryLat = 46.227638; /*France*/
    let countryLng = 2.213749; /*France*/
    let map;

    hideWrapper('location');
    locationArr('france');
    initMobMaps('france');
    mapInit();
    countriesFiltration();
    setAgencyCoordinate();

    function countriesFiltration() {
        let countrySelect = document.querySelector('.country-select');
        let filtrationBlocks = document.querySelectorAll('[data-country]');

        countrySelect.addEventListener('change', function (e) {
            let currentVal = e.target.value;
            filtrationBlocks.forEach((item) => {
                let dataCountry = item.getAttribute('data-country');
                if (dataCountry === currentVal) {
                    item.classList.add('show');
                } else {
                    item.classList.remove('show');
                }
            });
            document.getElementById('map').innerHTML = '';
            locationArr(currentVal);
            initMobMaps(currentVal);
            mapInit();
        })
    }

    function locationArr(currentVal) {
        let currentAgenciesWrap = document.querySelector(`[data-country = ${currentVal}]`);
        countryLat = currentAgenciesWrap.getAttribute('data-lat');
        countryLng = currentAgenciesWrap.getAttribute('data-lng');
        let currentAgencies = currentAgenciesWrap.querySelectorAll('.agencyCoordinate');
        locations = [];
        currentAgencies.forEach((item) => {
            let lat = item.getAttribute('data-lat');
            let lng = item.getAttribute('data-lng');
            let title = item.getAttribute('data-title');
            let locationSubArr = [];
            locationSubArr.push(title);
            locationSubArr.push(lat);
            locationSubArr.push(lng);
            locations.push(locationSubArr);
        });
    }

    function mapInit() {
        let myOptions = {
            center: new google.maps.LatLng(countryLat, countryLng),
            zoom: 5,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [{"featureType":"all","elementType":"geometry","stylers":[{"color":"#202c3e"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"gamma":0.01},{"lightness":20},{"weight":"1.39"},{"color":"#ffffff"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"weight":"0.96"},{"saturation":"9"},{"visibility":"on"},{"color":"#000000"}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"lightness":30},{"saturation":"9"},{"color":"#29446b"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"saturation":20}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"lightness":20},{"saturation":-20}]},{"featureType":"road","elementType":"geometry","stylers":[{"lightness":10},{"saturation":-30}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#193a55"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"saturation":25},{"lightness":25},{"weight":"0.01"}]},{"featureType":"water","elementType":"all","stylers":[{"lightness":-20}]}],
        };
        map = new google.maps.Map(document.getElementById('map'), myOptions);
      
        setMarkers(map, locations);
        
    }

    function setMarkers(map, locations) {
        if(locations.length > 0) {
            var marker, i, mark_position;
            for (i = 0; i < locations.length; i++) { // Проходимся по нашему массиву с марками

                // Тут вроде и так все понятно
                var title = locations[i][0];
                var lat = locations[i][1];
                var long = locations[i][2];
                var text = locations[i][3];

                mark_position = new google.maps.LatLng(lat, long); // Создаем позицию для отметки

                marker = new google.maps.Marker({ // Что будет содержаться в отметке
                    map: map, // К какой карте относиться отметка
                    title: title, // Заголовок отметки
                    position: mark_position, // Позиция отметки
                    animation: google.maps.Animation.DROP, // Анимация
                    icon: '' // Можно поменять иконку, если оставить пустые скобки, то будет оригинальная иконка
                });

                // Дальше создаем контент для каждой отметки

                // var content = '<div class="info-block"><h3>' + title + '</h3><b>' + "Address: </b>" + text + '</div>';
                var content = '<div class="info-block"><h3>' + title + '</h3></div>';
                var infowindow = new google.maps.InfoWindow();

                // При нажатии на марку, будет отображаться контент

                google.maps.event.addListener(marker, 'click', (function (marker, content, infowindow) {
                    return function () {
                        infowindow.setContent(content);
                        infowindow.open(map, marker);
                    };
                })(marker, content, infowindow));
            }
        }
    }

    function setAgencyCoordinate(){
        let agencyCoordininate = document.querySelectorAll('.agencyCoordinate');
        agencyCoordininate.forEach((item)=>{
            item.addEventListener('click', function(){
                if(window.innerWidth >= 768){
                    let currentLat = item.getAttribute('data-lat');
                    let currentLng = item.getAttribute('data-lng');
                    var latLng = new google.maps.LatLng(currentLat, currentLng); //Makes a latlng
                    map.panTo(latLng); //Make map global
                    map.setZoom(15);
                }
            });
        });
    }

    function initMobMaps(currentVal){
        let currentAgenciesWrap = document.querySelector(`[data-country = ${currentVal}]`);
        let agencyBlocks = currentAgenciesWrap.querySelectorAll('.city-info');
        if(window.innerWidth <= 1023) {
            agencyBlocks.forEach((item) => {
                let currentMobMap = item.querySelector('.mobile-map');
                let coordinatesHere = item.querySelector('.agencyCoordinate');
                let currentLat = coordinatesHere.getAttribute('data-lat');
                let currentLng = coordinatesHere.getAttribute('data-lng');
                let currentTitle = coordinatesHere.getAttribute('data-title');
                let locations = [];
                let locationSubArr = [];
                locationSubArr.push(currentTitle);
                locationSubArr.push(currentLat);
                locationSubArr.push(currentLng);
                locations.push(locationSubArr);
                let myOptions = {
                    center: new google.maps.LatLng(currentLat, currentLng),
                    zoom: 13,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };
                map = new google.maps.Map(currentMobMap, myOptions);
                setMarkers(map, locations);
            })
        }
    }
};
